import { render, staticRenderFns } from "./CardGallery.vue?vue&type=template&id=2a942a43&lang=pug"
import script from "./CardGallery.vue?vue&type=script&lang=js"
export * from "./CardGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports